import _ from 'lodash';
import { connect } from 'react-redux';
import { get as getLocation } from '../redux/modules/collections/location';
import { get as getLocationSupplement } from '../redux/modules/collections/locationSupplement';

function mapStateToProps(state, ownProps) {
	const locationId = ownProps.locationId;

	// defaults to passed in values so it doesn't overwrite them, in case you are using the component and already have your data
	return {
		location : _.get(state, ['collections', 'location', locationId], ownProps.location),
		locationSupplement : _.get(state, ['collections', 'locationSupplement', locationId], ownProps.locationSupplement),
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	const locationId = ownProps.locationId;

	// have to pass locationId in below because we don't have a reference of that...
	return {
		getLocation : () => dispatch(getLocation({locationIds : [locationId]})),
		getLocationSupplement : () => dispatch(getLocationSupplement({locationIds : [locationId]})),
	};
}

export default connect(mapStateToProps, mapDispatchToProps);